import { Typography } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import DisabledElement from 'components/disabledElement/disabledElement';

// styles
import 'ckeditor5/ckeditor5.css';

interface AnnouncementContentComponentProps {
	language: 'ar' | 'en';
	title: string;
	excerpt: string;
	content: string;
}

const AnnouncementContentComponent: FunctionComponent<AnnouncementContentComponentProps> = ({ language, title, excerpt, content }) => {
	const { t } = useTranslation();

	return (
		<>
			<div>
				<DisabledElement label={t(`ACTIONS.TITLE_IN_${language.toUpperCase()}`)} value={title} />
			</div>

			<div className="mt-4">
				<DisabledElement label={t(`ACTIONS.EXCERPT_IN_${language.toUpperCase()}`)} value={excerpt} />
			</div>

			<div className="mt-4">
				<Typography style={{ fontSize: 15, marginBottom: 10 }}>{t(`ACTIONS.CONTENT_IN_${language.toUpperCase()}`)}</Typography>
				<div style={{ padding: 10, border: '1px solid #f5f5f5', borderRadius: 'var(--radius)', direction: 'ltr' }}>
					<div dangerouslySetInnerHTML={{ __html: content }}></div>
				</div>
			</div>
		</>
	);
};

export default AnnouncementContentComponent;
